import { ImageStatus } from "./imageStatus";
import { Project } from "./project";

export interface Image {
    id: string;
    name: string;
    attachment?: string;
    url: string;
    thumbnail?: string;
    path?: string;
    tPath?: string;
    project?: string | Project;
    projectName: string;
    tracker?: string,
    trackerName: string,
    createdDate: string;
    src?: string;
    processed?: boolean;
    statuses?: ImageStatus[];
    database?: string;
    isCraneDisabled?: boolean;
    craneUpdated?: boolean;
    canValidate?: boolean;
    checkUpdated?: boolean;
    checked?: boolean;
    type?: 'photo'|'video';
    event?: string;
    video?: string;
    loading?: boolean;
    blob?: Blob;
    videoSrc?: string;
}

export interface PostImage {
    attachment: string;
    name: string;
    url: string;
    path: string;
    tPath: string;
    project?: string;
    tracker?: string;
    statuses?: string[];
    processed?: boolean;
    trackerName?: string;
    projectName?: string;
    database?: string;
    createdDate?: Date;
}

export interface PutImage {
    id: string;
    name?: string;
    url?: string;
    path?: string;
    tPath?: string;
    project?: string;
    tracker?: string;
    statuses?: string[];
    processed?: boolean;
    trackerName?: string;
    projectName?: string;
}

export const defaultImage: Image = {
    id: "",
    name: "",
    url: "",
    thumbnail: "",
    path: "",
    tPath: "",
    projectName: "",
    trackerName: "",
    createdDate: new Date().toISOString(),
    statuses: []
};
